import { FC } from 'react'
import { LabelItem } from '../../categoryDashboard.types'
import { LabelsWrapper, LabelSkeletonBar, CountSkeleton } from './labelsSection.styles'
import LabelCard from './LabelCard'
import { LabelsIcon } from '../icons'

interface Props {
  labels: LabelItem[]
  loading?: boolean
}

const SKELETON_COUNT = 8

const LabelsSection: FC<Props> = ({ labels, loading }) => {
  return (
    <LabelsWrapper>
      <div className="section-title">
        <LabelsIcon className="title-icon" />
        <span className="title-text">Labels</span>
        {loading ? <CountSkeleton /> : <span className="title-count">({labels.length})</span>}
      </div>
      {loading ? (
        <div className="labels-list">
          {Array.from({ length: SKELETON_COUNT }, (_, i) => (
            <LabelSkeletonBar key={i} />
          ))}
        </div>
      ) : labels.length === 0 ? (
        <div className="empty-state">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.46447 26.5355C7.41709 28.4882 10.5829 28.4882 12.5355 26.5355L21.0711 18M9 28C6.23858 28 4 25.7614 4 23V5.5C4 4.67157 4.67157 4 5.5 4H12.5C13.3284 4 14 4.67157 14 5.5V10.9289M9 28C11.7614 28 14 25.7614 14 23V10.9289M9 28H26.5C27.3284 28 28 27.3284 28 26.5V19.5C28 18.6716 27.3284 18 26.5 18H21.0711M14 10.9289L17.8388 7.0901C18.4246 6.50431 19.3744 6.50431 19.9602 7.0901L24.9099 12.0398C25.4957 12.6256 25.4957 13.5754 24.9099 14.1612L21.0711 18M9 23H9.01V23.01H9V23Z"
              stroke="#A88CA4"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="empty-title">No Labels Available</span>
          <span className="empty-description">Create your first label to start organizing this category.</span>
        </div>
      ) : (
        <div className="labels-list">
          {labels.map((label) => (
            <LabelCard key={label.id} label={label} />
          ))}
        </div>
      )}
    </LabelsWrapper>
  )
}

export default LabelsSection
